'use strict';

var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _assertThisInitialized = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var _require = require('buffer'),
    Buffer = _require.Buffer;

var _require2 = require('interface-datastore'),
    Key = _require2.Key,
    Adapter = _require2.Adapter;

var _require3 = require('./utils'),
    encodeBase32 = _require3.encodeBase32,
    keyToTopic = _require3.keyToTopic,
    topicToKey = _require3.topicToKey;

var errcode = require('err-code');

var debug = require('debug');

var log = debug('datastore-pubsub:publisher');
log.error = debug('datastore-pubsub:publisher:error'); // DatastorePubsub is responsible for providing an api for pubsub to be used as a datastore with
// [TieredDatastore]{@link https://github.com/ipfs/js-datastore-core/blob/master/src/tiered.js}

var DatastorePubsub = /*#__PURE__*/function (_Adapter) {
  _inherits(DatastorePubsub, _Adapter);

  var _super = _createSuper(DatastorePubsub);

  /**
   * Creates an instance of DatastorePubsub.
   * @param {*} pubsub - pubsub implementation.
   * @param {*} datastore - datastore instance.
   * @param {*} peerId - peer-id instance.
   * @param {Object} validator - validator functions.
   * @param {function(record, peerId, callback)} validator.validate - function to validate a record.
   * @param {function(received, current, callback)} validator.select - function to select the newest between two records.
   * @param {function(key, callback)} subscriptionKeyFn - optional function to manipulate the key topic received before processing it.
   * @memberof DatastorePubsub
   */
  function DatastorePubsub(pubsub, datastore, peerId, validator, subscriptionKeyFn) {
    var _this;

    _classCallCheck(this, DatastorePubsub);

    _this = _super.call(this);

    if (!validator) {
      throw errcode(new TypeError('missing validator'), 'ERR_INVALID_PARAMETERS');
    }

    if (typeof validator.validate !== 'function') {
      throw errcode(new TypeError('missing validate function'), 'ERR_INVALID_PARAMETERS');
    }

    if (typeof validator.select !== 'function') {
      throw errcode(new TypeError('missing select function'), 'ERR_INVALID_PARAMETERS');
    }

    if (subscriptionKeyFn && typeof subscriptionKeyFn !== 'function') {
      throw errcode(new TypeError('invalid subscriptionKeyFn received'), 'ERR_INVALID_PARAMETERS');
    }

    _this._pubsub = pubsub;
    _this._datastore = datastore;
    _this._peerId = peerId;
    _this._validator = validator;
    _this._handleSubscriptionKeyFn = subscriptionKeyFn; // Bind _onMessage function, which is called by pubsub.

    _this._onMessage = _this._onMessage.bind(_assertThisInitialized(_this));
    return _this;
  }
  /**
   * Publishes a value through pubsub.
   * @param {Buffer} key identifier of the value to be published.
   * @param {Buffer} val value to be propagated.
   * @returns {Promise}
   */


  _createClass(DatastorePubsub, [{
    key: "put",
    value: function () {
      var _put = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(key, val) {
        var errMsg, _errMsg, stringifiedTopic;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (Buffer.isBuffer(key)) {
                  _context.next = 4;
                  break;
                }

                errMsg = 'datastore key does not have a valid format';
                log.error(errMsg);
                throw errcode(new Error(errMsg), 'ERR_INVALID_DATASTORE_KEY');

              case 4:
                if (Buffer.isBuffer(val)) {
                  _context.next = 8;
                  break;
                }

                _errMsg = 'received value is not a buffer';
                log.error(_errMsg);
                throw errcode(new Error(_errMsg), 'ERR_INVALID_VALUE_RECEIVED');

              case 8:
                stringifiedTopic = keyToTopic(key);
                log("publish value for topic ".concat(stringifiedTopic)); // Publish record to pubsub

                return _context.abrupt("return", this._pubsub.publish(stringifiedTopic, val));

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function put(_x, _x2) {
        return _put.apply(this, arguments);
      }

      return put;
    }()
    /**
     * Try to subscribe a topic with Pubsub and returns the local value if available.
     * @param {Buffer} key identifier of the value to be subscribed.
     * @returns {Promise<Buffer>}
     */

  }, {
    key: "get",
    value: function () {
      var _get = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(key) {
        var errMsg, stringifiedTopic, subscriptions, _errMsg2;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (Buffer.isBuffer(key)) {
                  _context2.next = 4;
                  break;
                }

                errMsg = 'datastore key does not have a valid format';
                log.error(errMsg);
                throw errcode(new Error(errMsg), 'ERR_INVALID_DATASTORE_KEY');

              case 4:
                stringifiedTopic = keyToTopic(key);
                _context2.next = 7;
                return this._pubsub.getTopics();

              case 7:
                subscriptions = _context2.sent;

                if (!(subscriptions && Array.isArray(subscriptions) && subscriptions.indexOf(stringifiedTopic) > -1)) {
                  _context2.next = 10;
                  break;
                }

                return _context2.abrupt("return", this._getLocal(key));

              case 10:
                _context2.prev = 10;
                _context2.next = 13;
                return this._pubsub.subscribe(stringifiedTopic, this._onMessage);

              case 13:
                _context2.next = 20;
                break;

              case 15:
                _context2.prev = 15;
                _context2.t0 = _context2["catch"](10);
                _errMsg2 = "cannot subscribe topic ".concat(stringifiedTopic);
                log.error(_errMsg2);
                throw errcode(new Error(_errMsg2), 'ERR_SUBSCRIBING_TOPIC');

              case 20:
                log("subscribed values for key ".concat(stringifiedTopic));
                return _context2.abrupt("return", this._getLocal(key));

              case 22:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[10, 15]]);
      }));

      function get(_x3) {
        return _get.apply(this, arguments);
      }

      return get;
    }()
    /**
     * Unsubscribe topic.
     * @param {Buffer} key identifier of the value to unsubscribe.
     * @returns {void}
     */

  }, {
    key: "unsubscribe",
    value: function unsubscribe(key) {
      var stringifiedTopic = keyToTopic(key);
      return this._pubsub.unsubscribe(stringifiedTopic, this._onMessage);
    } // Get record from local datastore

  }, {
    key: "_getLocal",
    value: function () {
      var _getLocal2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(key) {
        var routingKey, dsVal, _errMsg3, errMsg, _errMsg4;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                // encode key - base32(/ipns/{cid})
                routingKey = new Key('/' + encodeBase32(key), false);
                _context3.prev = 1;
                _context3.next = 4;
                return this._datastore.get(routingKey);

              case 4:
                dsVal = _context3.sent;
                _context3.next = 16;
                break;

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3["catch"](1);

                if (!(_context3.t0.code !== 'ERR_NOT_FOUND')) {
                  _context3.next = 13;
                  break;
                }

                _errMsg3 = "unexpected error getting the ipns record for ".concat(routingKey.toString());
                log.error(_errMsg3);
                throw errcode(new Error(_errMsg3), 'ERR_UNEXPECTED_ERROR_GETTING_RECORD');

              case 13:
                errMsg = "local record requested was not found for ".concat(routingKey.toString());
                log.error(errMsg);
                throw errcode(new Error(errMsg), 'ERR_NOT_FOUND');

              case 16:
                if (Buffer.isBuffer(dsVal)) {
                  _context3.next = 20;
                  break;
                }

                _errMsg4 = 'found record that we couldn\'t convert to a value';
                log.error(_errMsg4);
                throw errcode(new Error(_errMsg4), 'ERR_INVALID_RECORD_RECEIVED');

              case 20:
                return _context3.abrupt("return", dsVal);

              case 21:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[1, 7]]);
      }));

      function _getLocal(_x4) {
        return _getLocal2.apply(this, arguments);
      }

      return _getLocal;
    }() // handles pubsub subscription messages

  }, {
    key: "_onMessage",
    value: function () {
      var _onMessage2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(msg) {
        var data, from, topicIDs, key, res;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                data = msg.data, from = msg.from, topicIDs = msg.topicIDs;
                _context4.prev = 1;
                key = topicToKey(topicIDs[0]);
                _context4.next = 9;
                break;

              case 5:
                _context4.prev = 5;
                _context4.t0 = _context4["catch"](1);
                log.error(_context4.t0);
                return _context4.abrupt("return");

              case 9:
                log("message received for topic ".concat(topicIDs[0])); // Stop if the message is from the peer (it already stored it while publishing to pubsub)

                if (!(from === this._peerId.toB58String())) {
                  _context4.next = 13;
                  break;
                }

                log('message discarded as it is from the same peer');
                return _context4.abrupt("return");

              case 13:
                if (!this._handleSubscriptionKeyFn) {
                  _context4.next = 25;
                  break;
                }

                _context4.prev = 14;
                _context4.next = 17;
                return this._handleSubscriptionKeyFn(key);

              case 17:
                res = _context4.sent;
                _context4.next = 24;
                break;

              case 20:
                _context4.prev = 20;
                _context4.t1 = _context4["catch"](14);
                log.error('message discarded by the subscriptionKeyFn');
                return _context4.abrupt("return");

              case 24:
                key = res;

              case 25:
                _context4.prev = 25;
                _context4.next = 28;
                return this._storeIfSubscriptionIsBetter(key, data);

              case 28:
                _context4.next = 33;
                break;

              case 30:
                _context4.prev = 30;
                _context4.t2 = _context4["catch"](25);
                log.error(_context4.t2);

              case 33:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[1, 5], [14, 20], [25, 30]]);
      }));

      function _onMessage(_x5) {
        return _onMessage2.apply(this, arguments);
      }

      return _onMessage;
    }() // Store the received record if it is better than the current stored

  }, {
    key: "_storeIfSubscriptionIsBetter",
    value: function () {
      var _storeIfSubscriptionIsBetter2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(key, data) {
        var isBetter;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                isBetter = false;
                _context5.prev = 1;
                _context5.next = 4;
                return this._isBetter(key, data);

              case 4:
                isBetter = _context5.sent;
                _context5.next = 11;
                break;

              case 7:
                _context5.prev = 7;
                _context5.t0 = _context5["catch"](1);

                if (!(_context5.t0.code !== 'ERR_NOT_VALID_RECORD')) {
                  _context5.next = 11;
                  break;
                }

                throw _context5.t0;

              case 11:
                if (!isBetter) {
                  _context5.next = 14;
                  break;
                }

                _context5.next = 14;
                return this._storeRecord(Buffer.from(key), data);

              case 14:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[1, 7]]);
      }));

      function _storeIfSubscriptionIsBetter(_x6, _x7) {
        return _storeIfSubscriptionIsBetter2.apply(this, arguments);
      }

      return _storeIfSubscriptionIsBetter;
    }() // Validate record according to the received validation function

  }, {
    key: "_validateRecord",
    value: function () {
      var _validateRecord2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(value, peerId) {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt("return", this._validator.validate(value, peerId));

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function _validateRecord(_x8, _x9) {
        return _validateRecord2.apply(this, arguments);
      }

      return _validateRecord;
    }() // Select the best record according to the received select function.

  }, {
    key: "_selectRecord",
    value: function () {
      var _selectRecord2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(receivedRecord, currentRecord) {
        var res;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this._validator.select(receivedRecord, currentRecord);

              case 2:
                res = _context7.sent;
                return _context7.abrupt("return", res === 0);

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function _selectRecord(_x10, _x11) {
        return _selectRecord2.apply(this, arguments);
      }

      return _selectRecord;
    }() // Verify if the record received through pubsub is valid and better than the one currently stored

  }, {
    key: "_isBetter",
    value: function () {
      var _isBetter2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(key, val) {
        var error, valid, errMsg, dsKey, currentRecord;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;
                _context8.next = 3;
                return this._validateRecord(val, key);

              case 3:
                valid = _context8.sent;
                _context8.next = 9;
                break;

              case 6:
                _context8.prev = 6;
                _context8.t0 = _context8["catch"](0);
                error = _context8.t0;

              case 9:
                if (!(error || !valid)) {
                  _context8.next = 13;
                  break;
                }

                errMsg = 'record received through pubsub is not valid';
                log.error(errMsg);
                throw errcode(new Error(errMsg), 'ERR_NOT_VALID_RECORD');

              case 13:
                // Get Local record
                dsKey = new Key(key);
                _context8.prev = 14;
                _context8.next = 17;
                return this._getLocal(dsKey.toBuffer());

              case 17:
                currentRecord = _context8.sent;
                _context8.next = 23;
                break;

              case 20:
                _context8.prev = 20;
                _context8.t1 = _context8["catch"](14);
                return _context8.abrupt("return", true);

              case 23:
                if (!currentRecord.equals(val)) {
                  _context8.next = 25;
                  break;
                }

                return _context8.abrupt("return", false);

              case 25:
                return _context8.abrupt("return", this._selectRecord(val, currentRecord));

              case 26:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this, [[0, 6], [14, 20]]);
      }));

      function _isBetter(_x12, _x13) {
        return _isBetter2.apply(this, arguments);
      }

      return _isBetter;
    }() // add record to datastore

  }, {
    key: "_storeRecord",
    value: function () {
      var _storeRecord2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(key, data) {
        var routingKey;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                // encode key - base32(/ipns/{cid})
                routingKey = new Key('/' + encodeBase32(key), false);
                _context9.next = 3;
                return this._datastore.put(routingKey, data);

              case 3:
                log("record for ".concat(keyToTopic(key), " was stored in the datastore"));

              case 4:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function _storeRecord(_x14, _x15) {
        return _storeRecord2.apply(this, arguments);
      }

      return _storeRecord;
    }()
  }, {
    key: "open",
    value: function open() {
      var errMsg = 'open function was not implemented yet';
      log.error(errMsg);
      throw errcode(new Error(errMsg), 'ERR_NOT_IMPLEMENTED_YET');
    }
  }, {
    key: "has",
    value: function has(key) {
      var errMsg = 'has function was not implemented yet';
      log.error(errMsg);
      throw errcode(new Error(errMsg), 'ERR_NOT_IMPLEMENTED_YET');
    }
  }, {
    key: "delete",
    value: function _delete(key) {
      var errMsg = 'delete function was not implemented yet';
      log.error(errMsg);
      throw errcode(new Error(errMsg), 'ERR_NOT_IMPLEMENTED_YET');
    }
  }, {
    key: "close",
    value: function close() {
      var errMsg = 'close function was not implemented yet';
      log.error(errMsg);
      throw errcode(new Error(errMsg), 'ERR_NOT_IMPLEMENTED_YET');
    }
  }, {
    key: "batch",
    value: function batch() {
      var errMsg = 'batch function was not implemented yet';
      log.error(errMsg);
      throw errcode(new Error(errMsg), 'ERR_NOT_IMPLEMENTED_YET');
    }
  }, {
    key: "query",
    value: function query() {
      var errMsg = 'query function was not implemented yet';
      log.error(errMsg);
      throw errcode(new Error(errMsg), 'ERR_NOT_IMPLEMENTED_YET');
    }
  }]);

  return DatastorePubsub;
}(Adapter);

exports = module.exports = DatastorePubsub;